import i18next from 'i18next';

/**
 * Formátuje čas s dátumom ak je správa staršia ako 1 deň
 * @param {Date|string|number} timestamp - Timestamp (Date objekt, ISO string alebo číslo v ms)
 * @returns {string} Formátovaný čas, napr. "14:30" alebo "14:30 1.12"
 */
export const formatTimeWithDate = (timestamp) => {
  if (!timestamp) {
    return '';
  }

  // Konvertovať timestamp na Date objekt ak nie je
  let date;
  if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  } else if (typeof timestamp === 'number') {
    date = new Date(timestamp);
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else {
    return '';
  }

  // Skontroluj či je dátum validný
  if (isNaN(date.getTime())) {
    return '';
  }

  // Formátovať čas
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const timeStr = `${hours}:${minutes}`;

  // Zistiť či je správa staršia ako 1 deň
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const messageDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  // Rozdiel v milisekundách medzi dňami
  const dayDiff = (todayStart - messageDate) / (1000 * 60 * 60 * 24);

  // Ak je staršia ako 1 deň, pridaj krátky formát dátumu (deň.mesiac)
  if (dayDiff > 1) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${timeStr} ${day}.${month}`;
  }

  // Ak je z včera
  if (dayDiff > 0 && dayDiff <= 1) {
    return `${timeStr} ${i18next.t('yesterday', { ns: 'global' })}`;
  }

  // Ak je dnešný, vráť len čas
  return timeStr;
};
